<p>pricing-models-create works!</p>
